import React from 'react'
import { Container } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { CookieConsent } from './shared/CookieConsent'
import { Footer, Header } from './shared'

export interface DefaultLayoutProps {
  children: React.ReactNode
  className?: string
  withMargins?: boolean
}

export const DefaultLayout = ({
  children,
  className,
  withMargins = true
}: DefaultLayoutProps): JSX.Element => {
  return (
    <Root className={className}>
      {/*@ts-expect-error*/}
      <Header />
      {withMargins && (
        <Container maxW='1200px' py={{ xs: '10rpx', sm: '20rpx', md: '40rpx' }}>
          {children}
        </Container>
      )}
      {!withMargins && <>{children}</>}
      {/*@ts-expect-error*/}
      <Footer />
      <CookieConsent />
    </Root>
  )
}

const Root = styled.div``
